import { useRouter } from "next/router";
import Script from "next/script"; // Next.js component to load external scripts
import { useEffect } from "react";

import { gaId } from "@app/constants";

export const GAScript: React.FC = () => {
  const router = useRouter();

  useEffect(() => {
    if (!gaId) return;

    const handleRouteChange = (url: string) => {
      if (typeof window.gtag === "function") {
        if (gaId) {
          (window as any).gtag("config", gaId, {
            page_path: url,
          });
        }
      }
    };

    // Listen to route changes and track page views
    router.events.on("routeChangeComplete", handleRouteChange);

    // Clean up the event listener when the component unmounts
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events, gaId]);

  if (!gaId) {
    return null;
  }

  return (
    <>
      {/* GA4 Script to load the analytics library */}
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
      />
      <Script
        id="gtag-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gaId}', {
              page_path: window.location.pathname,
            });
          `,
        }}
      />
    </>
  );
};
